module.exports = __webpack_public_path__ + "img/全生命周期模型管理.64bcf0e3.png";